<mat-card>
  <mat-card-header>
    <mat-card-title>Création de correspondance</mat-card-title>
  </mat-card-header>
  <form [formGroup]="correspondanceForm" style="padding: 16x">
    <div class="column">
      <mat-form-field>
        <mat-label>Code Divalto</mat-label>
        <input matInput formControlName="codeDivalto" required />
      </mat-form-field>
      <mat-form-field>
        <mat-label>Libelle Divalto</mat-label>
        <input matInput formControlName="libelleDivalto" required />
      </mat-form-field>
      <mat-form-field>
        <mat-label>Libelle RG</mat-label>
        <input matInput formControlName="libelleRg" required />
      </mat-form-field>
      <mat-form-field>
        <mat-label>Libelle BitDefender</mat-label>
        <input matInput formControlName="libelleBit" required />
      </mat-form-field>
    </div>

    <div class="row" style="justify-content: space-between" mat-dialog-actions>
      <button mat-raised-button color="warn" mat-dialog-close>Annuler</button>
      <button
        mat-raised-button
        color="primary"
        [disabled]="correspondanceForm.invalid"
        (click)="formSubmit()"
        mat-dialog-close
        type="submit"
      >
        Valider
      </button>
    </div>
  </form>
</mat-card>
